import * as React from 'react';
export default (function (props) {
    return React.createElement(
        'div',
        { className: props.className, onClick: props.onClick },
        props.children
    );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/table/FilterDropdownMenuWrapper.js
// module id = 840
// module chunks = 1